<template>
  <canvas
    :id="'barcode_'+id"
    width="width"
    height="height"
  />
</template>

<script>

// eslint-disable-next-line import/named
import { barcode } from '@core/utils/utils'

export default {
  props: {
    id: {
      type: String,
      default: () => '',
    },
    width: {
      type: String,
      default: () => '120px',
    },
    height: {
      type: String,
      default: () => '80px',
    },
    includetext: {
      type: Boolean,
      default: () => true,
    },
  },
  mounted() {
    this.codeGenerator(this.id, this.includetext)
  },
  methods: {
    async codeGenerator(waybill, includetext) {
      barcode(`barcode_${waybill}`, waybill, includetext)
    },
  },
}
</script>
